export class Constants {
  /*screen size */
  static MOBILE = "(min-width:1000px)";
  static SERVER_ERROR = "Server error. Please try after sometime.";
  static OTP_ERROR = "OTP entered is wrong. Please enter correct OTP.";
  static AUTHORIZATION_ERROR = "You are not an authorized user.";
  static CRYPTO_KEY = "inthebeginninggg";
}
